<template>
	<div class="page2_main_layout_phone" id="page2_main_layout_phone">
		<div class="page2_main_title">
			产品中心
		</div>
		<div class="product_center_phone_title" @click="phone_product_list_btn(1)" style="margin-top: 60px;">
			智能设备

			<div class="product_center_phone_title_status" v-if="phone_product_list_show.includes(1)">
				收起
				<div class="status_up_ico"></div>
			</div>
			<div class="product_center_phone_title_status" v-else>
				展开
				<div class="status_down_ico"></div>
			</div>
		</div>
		<div class="phone_product_list_1" v-if="phone_product_list_show.includes(1)">
			<div class="phone_product_list_item" :id="'1_' + item.id" v-for="item in product_list_data_1"
				@click="show_one_product('1_' + item.id)">
				<!-- :style="item.style" -->
				<div :class="'phone_product_list_item_img ' + 'page_new_content_item_img_' + item.id">

				</div>
				<div class="phone_product_list_item_title">
					{{ item.title }}
				</div>
				<div class="phone_product_list_item_content">
					{{ item.content }}
				</div>

			</div>
		</div>
		<div class="product_center_phone_title" @click="phone_product_list_btn(2)">
			软件系统
			<div class="product_center_phone_title_status" v-if="phone_product_list_show.includes(2)">
				收起
				<div class="status_up_ico"></div>
			</div>
			<div class="product_center_phone_title_status" v-else>
				展开
				<div class="status_down_ico"></div>
			</div>
		</div>
		<div class="phone_product_list_1" v-if="phone_product_list_show.includes(2)">
			<div class="phone_product_list_item" :id="'2_' + item.id" v-for="item in product_list_data_2"
				@click="show_one_product('2_' + item.id)">
				<div :class="'phone_product_list_item_img ' + 'page_new_content_item_img_2_' + item.id">

				</div>
				<div class="phone_product_list_item_title">
					{{ item.title }}
				</div>
				<div class="phone_product_list_item_content">
					{{ item.content }}
				</div>

			</div>
		</div>
		<div class="product_center_phone_title" @click="phone_product_list_btn(3)">
			<!-- 软件定制 -->
			AI工具试用
			<div class="product_center_phone_title_status" v-if="phone_product_list_show.includes(3)">
				收起
				<div class="status_up_ico"></div>
			</div>
			<div class="product_center_phone_title_status" v-else>
				展开
				<div class="status_down_ico"></div>
			</div>
		</div>
		<div class="phone_product_list_1" v-if="phone_product_list_show.includes(3)">
			<div class="phone_product_list_item" :id="'3_' + item.id" v-for="item in api_list_data"
				@click="click_one_api_btn(item)">
				<div :class="'phone_product_list_item_img_3 ' + 'api_show_img_' + item.id">

				</div>
				<div class="phone_product_list_item_title">
					{{ item.title }}
				</div>
				<div class="phone_product_list_item_content">
					{{ item.content }}
				</div>

			</div>
		</div>
		<div style="width: 100%;height: 60px;float: left;">

		</div>

	</div>
	<div class="page1_main_layout">
		<div class="page2_main_content_layout" id="page2_section1" style="display: none;">
			<div class="page2_content_title">
				<div class="page2_content_title_icon page2_content_title_icon_1"></div>
				<div class="page2_content_title_text">
					智能设备
				</div>
			</div>
			<!-- 				:style="item.id%5==0?'height: 360px;margin-right: 0px;':'height: 360px;margin-bottom: 20px;'" -->
			<div class="page2_content_item" v-for="item in product_list_data_1"
				@click="show_one_product('1_' + item.id)">
				<div class="page2_content_item_layout">
					<div class="page2_content_item_title">
						{{ item['title'] }}
					</div>

					<div :class="'page2_content_item_img ' + 'page_new_content_item_img_' + item.id"
						:style="'margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;' + item.style">

					</div>
					<!-- <div class="page2_content_item_text" style="height: 110px;">
						{{ item['content'] }}
					</div> -->
				</div>

			</div>


		</div>

		<div class="page2_main_content_layout" id="page2_section2" style="display: none;">
			<div class="page2_content_title">
				<div class="page2_content_title_icon page2_content_title_icon_2"></div>
				<div class="page2_content_title_text">
					软件系统
				</div>
			</div>
			<!-- <div class="page2_content_item_2" v-for="item in product_list_data_2" -->
			<div class="page2_content_item_2" v-for="item in product_list_data_2"
				@click="show_one_product('2_' + item.id)">
				<div class="page2_content_item_layout">
					<div class="page2_content_item_title">
						{{ item['title'] }}
					</div>

					<div :class="'page2_content_item_img ' + 'page_new_content_item_img_2_' + item.id"
						:style="'margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;' + item.style">

					</div>
					<!-- <div class="page2_content_item_text" style="height: 110px;">
						{{ item['content'] }}
					</div> -->
				</div>


			</div>


		</div>

		<div class="page2_main_content_layout" style="margin-bottom: 90px;display: none;" id="page2_section3">
			<div class="page2_content_title">
				<div class="page2_content_title_icon page2_content_title_icon_3"></div>
				<div class="page2_content_title_text">
					<!-- 软件定制 -->
					AI工具试用
				</div>
			</div>
			<div class="page2_content_item_3" v-for="item in api_list_data" @click="click_one_api_btn(item)">
				<div class="page2_content_item_layout">
					<div class="page2_content_item_title">
						{{ item['title'] }}
					</div>

					<div :class="'page2_content_ai_item_img ' + 'api_show_img_' + item.id"
						style="margin-top: 10px;margin-left: 29px;height: 180px;width: 170px;">

					</div>
					<!-- <div class="page2_content_item_text" style="height: 110px;">
						{{ item['content'] }}
					</div> -->
				</div>


			</div>


		</div>

	</div>
	<Footer></Footer>

</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page2",
	components: {
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			api_list_data: [],
			product_list_data_1: [],
			product_list_data_2: [],
			phone_product_list_show: [1, 2, 3]
		}
	},
	mounted() {
		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		this.api_list_data = this.$GLOBAL.api_list_data
		this.product_list_data_1 = this.$GLOBAL.product_list_data_1
		this.product_list_data_2 = this.$GLOBAL.product_list_data_2

		let sub_id = window.localStorage.getItem("sub_id")
		if (sub_id == 1) {
			this.phone_product_list_show = [1]
		} else if (sub_id == 2) {
			this.phone_product_list_show = [2]
		} else if (sub_id == 3) {
			this.phone_product_list_show = [3]
		}

		// let sub_item_id = window.localStorage.getItem("sub_item_id")
		// let element = document.getElementById(sub_item_id);
		// console.log(sub_item_id)
		// console.log(element)

		// if(element){
		// 	element.scrollIntoView({ behavior: 'smooth' });
		// }




		this.$GLOBAL.methods.init_header_menu("page2")
		// console.log(this.api_list_data)

		// request.get(this.$GLOBAL.flask_web_local_url+'/get_map_data_info').then(res => {
		// 	console.log(res)
		// })

		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_1', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_2', 'rgba(85, 255, 255, 0.7)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_3', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_4', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_5', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_6', 'rgba(255, 255, 255, 0.4)')


		setTimeout(function () {
			let item_list = document.getElementsByClassName("page2_content_item")
			// console.log(item_list.length)
			for (let i = 0; i < item_list.length; i++) {
				if (i != 0 && (i + 1) % 5 == 0) {
					item_list[i].style.marginRight = "0px"
					// console.log(item_list[i])
				}
			}
			item_list = document.getElementsByClassName("page2_content_item_2")
			// console.log(item_list.length)
			for (let i = 0; i < item_list.length; i++) {
				if (i != 0 && (i + 1) % 5 == 0) {
					item_list[i].style.marginRight = "0px"
					// console.log(item_list[i])
				}
			}
			item_list = document.getElementsByClassName("page2_content_item_3")
			// console.log(item_list.length)
			for (let i = 0; i < item_list.length; i++) {
				if (i != 0 && (i + 1) % 5 == 0) {
					item_list[i].style.marginRight = "0px"
					// console.log(item_list[i])
				}
			}
			let layout_obj = document.getElementsByClassName("page2_main_content_layout")
			for (let j = 0; j < layout_obj.length; j++) {
				layout_obj[j].style.display = ""
			}

			let sub_item_id = window.localStorage.getItem("sub_item_id")
			var element = document.getElementById(sub_item_id);
			if (element) {
				var offset = element.offsetTop;
				document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = offset
				// 	window.scrollTo({
				// 	  top: offset ,
				// 	  behavior: 'smooth'
				// 	});
			}
			// // 滚动到垂直距离100像素的位置
			// 滚动到垂直距离100像素的位置

		}, 20)

		// let sub_item_id = window.localStorage.getItem("sub_item_id")



	},
	methods: {
		click_page2_show_menu(index) {

			// document.getElementById("page2_show_menu_item_"+index).click();
			// console.log(document.getElementById("page2_show_menu_item_"+index))
			// window.localStorage.setItem("show_id",item.id);
			// this.$router.push("/main/page_api_1")
		},
		show_one_product(id) {
			window.localStorage.setItem("sub_id", id[0])
			window.localStorage.setItem("sub_item_id", id);
			window.localStorage.setItem("sub_path", id);
			window.localStorage.setItem("main_path", "show_product");
			this.$router.push("/main/show_product")
		},
		click_one_api_btn(item) {
			console.log(item)
			// window.localStorage.setItem("sub_id",item.id);
			window.localStorage.setItem("sub_id", 3);
			window.localStorage.setItem("sub_item_id", "3_" + item.id);

			window.localStorage.setItem("show_id", item.id);
			if (item.show_style.indexOf("AI") != -1) {
				this.$router.push("/main/" + item.show_style)
			} else {
				// window.localStorage.setItem("main_path","page_api_1");
				this.$router.push("/main/page_api_1")
			}

		},
		phone_product_list_btn(id) {
			window.localStorage.setItem("sub_id", id);

			if (this.phone_product_list_show.includes(id)) {
				let index = this.phone_product_list_show.indexOf(id);
				if (index > -1) {
					this.phone_product_list_show.splice(index, 1);
				}
			} else {
				this.phone_product_list_show.push(id)
			}


		},
	},
}
</script>

<style></style>